import { render, staticRenderFns } from "./BookOfAuthoritiesAppRightToAppealPg.vue?vue&type=template&id=3dfe5323&scoped=true"
import script from "./BookOfAuthoritiesAppRightToAppealPg.vue?vue&type=script&lang=ts"
export * from "./BookOfAuthoritiesAppRightToAppealPg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfe5323",
  null
  
)

export default component.exports